import type {ReactElement} from 'react';
import React from 'react';
import type {CustomDashSizeOptionProps} from '@Components/poster-editor/components/poster-editing-side-panel/components/line-dash-option/components/custom-dash-size-option/custom-dash-size-option.types';
import {
  CUSTOM_DASH_MAX_SIZE,
  CUSTOM_DASH_MIN_SIZE,
} from '@Components/poster-editor/components/poster-editing-side-panel/components/line-dash-option/components/custom-dash-size-option/custom-dash-size-option.types';
import {ContextualMenuSliderOptions} from '@Components/contextual-menu/components/contextual-menu-slider-options';

export function CustomDashSizeOption({...props}: CustomDashSizeOptionProps): ReactElement {
  const onChangeDashSize = (dashSize: number): void => {
    props.onUpdateDashSize(dashSize, false);
  };

  const onChangeDashSizeEnded = (dashSize: number): void => {
    props.onUpdateDashSize(dashSize);
  };

  return (
    <ContextualMenuSliderOptions
      id="custom-line-dash-size"
      className={props.className}
      value={props.dashSize}
      label={window.i18next.t('pmwjs_dash_size')}
      range={{
        min: CUSTOM_DASH_MIN_SIZE,
        max: CUSTOM_DASH_MAX_SIZE,
      }}
      transformDisplay={{
        min: CUSTOM_DASH_MIN_SIZE,
        max: CUSTOM_DASH_MAX_SIZE,
      }}
      onChange={onChangeDashSize}
      onChangeEnded={onChangeDashSizeEnded}
    />
  );
}
